// Immediate (non-debounced) SQLite storage adapter.
// Used by useSessionStore for crash-critical fields (documentSequence, locked).
// Same API as sqliteStorage.js but writes synchronously to SQLite without debounce.

const sqliteImmediateStorage = {
  getItem: async (name) => {
    try {
      if (window.electronAPI?.appState) {
        const sqliteValue = await window.electronAPI.appState.get(name);
        if (sqliteValue != null) return sqliteValue;
        // Fall through to localStorage (pending IPC write or first boot)
      }
    } catch (e) {
      console.warn("[sqliteImmediateStorage] getItem failed, falling back to localStorage:", e);
    }
    return localStorage.getItem(name);
  },

  setItem: (name, value) => {
    // Write to localStorage synchronously as immediate fallback
    try {
      localStorage.setItem(name, value);
    } catch (e) {
      // localStorage full or unavailable — SQLite is primary anyway
    }

    // Immediate async write to SQLite (no debounce)
    if (window.electronAPI?.appState) {
      window.electronAPI.appState.put(name, value).catch((e) => {
        console.warn("[sqliteImmediateStorage] setItem failed:", e);
      });
    }
  },

  removeItem: (name) => {
    try {
      localStorage.removeItem(name);
    } catch (e) {
      // ignore
    }
    if (window.electronAPI?.appState) {
      window.electronAPI.appState.delete(name).catch((e) => {
        console.warn("[sqliteImmediateStorage] removeItem failed:", e);
      });
    }
  },
};

export default sqliteImmediateStorage;
